<div
  data-at-floor-heating-over-heating-error
  class="error-container flex flex-col gap-[16px] justify-start items-start"
>
  <div class="error-title">
    {{
      '+INSTALLATIONS.INSTALLATION.ERROR_LIST.FLOOR_HEATING_OVER_HEATING_ERROR.TITLE' | translate
    }}
  </div>

  <div class="flex flex-col gap-[8px] justify-start items-start">
    <div class="date">{{ installationLocalTimeOfErrorCreatedAt | date: 'short' }}</div>
    <div class="error-description">
      {{
        '+INSTALLATIONS.INSTALLATION.ERROR_LIST.FLOOR_HEATING_OVER_HEATING_ERROR.DESCRIPTION'
          | translate
      }}
    </div>
  </div>
</div>
